import { Button, Menu, Stack, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  BoltIcon,
  ConfirmationNumberIcon,
  ShoppingCartIcon,
} from "../../common/iconsData";

const StyledLink = styled(Link)`
  text-align: center;
  text-decoration: none;
  font-size: 14px;
  color: #0e1f2e;
  background-color: #f8fafd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  width: 180px;
  row-gap: 20px;

  &:hover {
    background-color: #eaf2fe;
  }
`;

const QuickActions = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);
  const username = localStorage.getItem("hipship-username") || "User";
  const isUser = username === "Cipla";

  return (
    <>
      <Button variant="text" onClick={handleClick}>
        <BoltIcon
          sx={{
            color: "#fff",
          }}
          fontSize="small"
        />
        <Typography color={"#fff"} fontSize={"14px"} textTransform={"none"}>
          Quick Actions
        </Typography>
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <Stack
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          padding={"20px"}
          flexWrap={"wrap"}
          gap={2}
        >
          {!isUser &&(
          <StyledLink to={"/order/add-order"} onClick={handleClose}>
            <ShoppingCartIcon fontSize="large" />
            <p>Add an Order</p>
          </StyledLink>)}
          {/* <StyledLink to={"/order/add-order"} onClick={handleClose}>
            <LocalShippingIcon fontSize="large" />
            <p>Quick Shipment</p>
          </StyledLink> */}
          {/* <StyledLink to={"/tools/rate-calculator"} onClick={handleClose}>
            <CalculateIcon fontSize="large" />
            <p>Rate Calculator</p>
          </StyledLink> */}
          <StyledLink to={"/support-and-help"} onClick={handleClose}>
            <ConfirmationNumberIcon fontSize="large" />
            <p>Create a Ticket</p>
          </StyledLink>
          {/* <StyledLink to={"/track"} onClick={handleClose}>
            <LocationSearchingIcon fontSize="large" />
            <p>Track Shipments</p>
          </StyledLink> */}
        </Stack>
      </Menu>
    </>
  );
};

export default QuickActions;
